import { AttackEventFilterArg } from '../types/attack-event-filter-arg'

export function mapAttackEventFilters(filters: AttackEventFilterArg) {
  const {
    applications = [],
    attackers = [],
    environments = [],
    results = [],
    rules = [],
    servers = [],
    severities = [],
    tags = [],
    sourceNameIDs = [],
    filterText,
    quickFilter,
    startDate,
    endDate,
    includeIpBlacklist,
    includeBotBlockers,
    includeSuppressed
  } = filters

  return {
    applications,
    attackers,
    environments,
    results,
    rules,
    servers,
    severities,
    tags,
    sourceNameIDs,
    filterText,
    quickFilter,
    startDate,
    endDate,
    includeIpBlacklist,
    includeBotBlockers,
    includeSuppressed
  }
}

export function appendAttackEventFiltersToBody(
  filters: AttackEventFilterArg | undefined
) {
  if (filters) {
    const {
      applications,
      attackers,
      environments,
      results,
      rules,
      servers,
      severities,
      tags,
      sourceNameIDs,
      filterText,
      quickFilter,
      startDate,
      endDate,
      includeIpBlacklist,
      includeBotBlockers,
      includeSuppressed
    } = mapAttackEventFilters(filters)

    let body: any = {
      quickFilter: quickFilter ? quickFilter : 'ALL',
      applications,
      attackers,
      environments,
      results,
      rules,
      servers,
      severities,
      tags,
      sourceNameIDs
    }

    if (filterText) {
      body = {
        ...body,
        keyword: filterText
      }
    }

    if (startDate) {
      body = {
        ...body,
        startDate
      }
    }
    if (endDate) {
      body = {
        ...body,
        endDate
      }
    }
    if (includeSuppressed) {
      body = {
        ...body,
        includeSuppressed
      }
    }
    if (includeBotBlockers) {
      body = {
        ...body,
        includeBotBlockers
      }
    }
    if (includeIpBlacklist) {
      body = {
        ...body,
        includeIpBlacklist
      }
    }

    return body
  }
  return {}
}
